let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aIUVr")).then(() => parcelRequire('jT6QL'));